<script>
import {Line} from 'vue-chartjs'
import {trans} from "../../../app";
import {getColor} from "../../../utils/colors";

export default {
    extends: Line,
    methods: {
        setOrdersData(ordersData) {
            this.ordersData = ordersData;
            this.renderChart({
                labels: this.labels,
                datasets: this.datasets,
            }, this.options);
        }
    },
    data: () => ({
        ordersData: [],
        options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                    }
                }]
            },
            elements: {
                line: {
                    fill: false
                }
            },
        }
    }),
    computed: {
        datasets() {
            let datasets = [
                {
                    label: trans('app.statistics.orders.paid_orders'),
                    data: this.ordersData.map((row) => {
                        return row.paid_orders;
                    }),
                },
                {
                    label: trans('app.statistics.premium_total'),
                    data: this.ordersData.map((row) => {
                        return row.premium_total;
                    }),
                },
                {
                    label: trans('app.statistics.standard_total'),
                    data: this.ordersData.map((row) => {
                        return row.standard_total;
                    }),
                },
                {
                    label: trans('app.statistics.student_total'),
                    data: this.ordersData.map((row) => {
                        return row.student_total;
                    }),
                },
                {
                    label: trans('app.statistics.orders.individual_orders'),
                    data: this.ordersData.map((row) => {
                        return row.individual_orders;
                    }),
                },
            ];
            datasets = datasets.map((dataset, index) => {
                dataset.borderColor = getColor(index)
                return dataset;
            })
            return datasets;
        },
        labels() {
            return this.ordersData.map((row) => {
                return row.date
            });
        }
    },
    mounted() {
        this.renderChart({
            labels: this.labels,
            datasets: this.datasets
        }, this.options)
    }
}
</script>